import React from "react";
import "../TopUpModal/topUpModal.css";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import moment from "moment";
import Select from "react-select";
import {
  GET_SELLERS,
  GET_SINGLE_FUNDS_DATA,
  GET_WALLET_BALANCE,
} from "../../../store/types";
import {
  getSellerWalletDetails,
  AdjustWalletDetails,
  getSellers,
  getSellersByCompanyId,
} from "../../../store/actions/fundManagement";
import DatePicker from "react-datepicker";
import { transactionType } from "../../../constant";
import PropTypes from "prop-types";
import InputCalculator from "../../common/InputCalculator";

const isAdjustmentFormValid = (formData) => Boolean(
  formData?.topupCompanyId &&
  formData?.amount > 0 &&
  formData?.topupSellerId &&
  formData?.transactionType
);

const getAdjustmentValidationErrors = (formData) => {
  const hasAmount = Number(formData?.amount) > 0;
  const hasCompany = Boolean(formData?.topupCompanyId);
  const hasSeller = Boolean(formData?.topupSellerId?.label);
  const hasTransactionType = Boolean(formData?.transactionType);

  if (
    !hasCompany &&
    !hasAmount &&
    !hasSeller &&
    !hasTransactionType
  ) {
    return {
      SellerName: "This is a mandatory field",
      amount: "Amount should not be empty or 0",
      topupSellerId: "This is a mandatory field",
      transactionType: "Please select transaction type",
    };
  }
  if (!hasAmount && !hasSeller) {
    return {
      amount: "Amount should not be empty or 0",
      topupSellerId: "This is a mandatory field",
    };
  }
  if (!hasCompany) {
    return { SellerName: "This is a mandatory field" };
  }
  if (!hasTransactionType) {
    return { transactionType: "Please select transaction type" };
  }
  if (!hasAmount) {
    return { amount: "Amount should not be empty or 0" };
  }
  if (!hasSeller) {
    return { topupSellerId: "This is a mandatory field" };
  }
  return null;
};

function PriceAdjustModal(props) {
  const { fundList, activeSellerList, showModal = true } = props;
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [currentUserDetails, setCurrentUserDetails] = useState({});
  const [sellerList, setSellerList] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [selectedsellerData, setselectedSellerData] = useState();
  const [amount, setAmount] = useState(null);
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const { companyList } = useSelector((state) => state?.auth);
  const getSellersValue = useSelector(
    (state) => state?.FundManagementReducer?.getSellersDetail?.EntityList
  );
  const sellerWalletBalance = useSelector(
    (state) => state?.FundManagementReducer?.getSellerWalletBalance?.EntityList
  );
  const createdBy = useSelector((state) => state?.auth?.user);

  useEffect(() => {
    if (companyList.length) {
      let findDefault = companyList.filter(item => item.isDefault)[0]; // NOSONAR
      setCurrentUserDetails(findDefault);
    }
  }, [companyList]);

  useEffect(() => {
    setselectedSellerData("");
  }, [amount]);

  useEffect(() => {
    handleCompanySellerDefault();
    if (!createdBy?.Value?.isSuperAdmin) {
      let filterSuperAdmin = transactionType.filter(item => item.permission === 'all'); // NOSONAR
      setTransactionTypeList(filterSuperAdmin);
    } else {
      setTransactionTypeList(transactionType);
    }
  }, []);

  const handleCompanySellerDefault = async () => {
    if (fundList?.length && activeSellerList.length) {
      let findChecked = fundList.filter(item => item.isChecked);
      if (findChecked.length) {
        getSellersByCompanyId(findChecked[0].companyId)?.then((resp) => {
          let data = resp?.data?.EntityList.map((item) => {
            return {
              label: item.sellerName,
              value: item.sellerId,
            };
          });
          setSellerList(data);
          let findInCompanyList = activeSellerList.filter(item => item.Id === findChecked[0].companyId)[0] || []; // NOSONAR
          let findInSellerList = data?.filter(item => item.value === findChecked[0].sellerId)[0] || []; // NOSONAR
          setFormData({
            ...formData,
            topupCompanyId: findInCompanyList,
            topupSellerId: findInSellerList
          })
        })
      }
    }
  }

  const [formData, setFormData] = useState({
    createdBy: createdBy?.Value?.employeeId,
    companyId: createdBy?.Value?.companyId,
    sellerId: createdBy?.Value?.sellerId,
    SellerName: {},
    isActive: true,
    id: selectedsellerData?.id,
    amount: 0,
    topupCompanyId: null,
    shouldSendEmail: false,
  });

  useEffect(() => {
    if (getSellersValue?.length) {
      let data = getSellersValue.map((item) => {
        return {
          value: item.sellerId,
          label: item.sellerName,
        };
      });
      if (formData.transactionType === 7 || formData.transactionType === 8) {
        let findSeller = data.filter(item => item.value === currentUserDetails.sellerId)[0]; // NOSONAR
        setFormData({
          ...formData,
          topupSellerId: findSeller,
        });
      } else if (data.length === 1) {
        // Auto-select the lone seller when the selected company has exactly one
        setFormData(prev => (prev?.topupSellerId?.value ? prev : { ...prev, topupSellerId: data[0] }));
      }
      setSellerList(data);
    } else {
      setSellerList([]);
    }
  }, [getSellersValue]);

  useEffect(() => {
    if (formData?.topupCompanyId?.value) {
      if (formData?.topupSellerId?.value) {
        dispatch(
          getSellerWalletDetails({
            topupCompanyId: formData?.topupCompanyId?.value,
            topupSellerId: formData?.topupSellerId?.value,
          })
        );
      }
    }
  }, [formData.topupCompanyId, formData.topupSellerId]);

  useEffect(() => {
    if (formData.transactionType === 7 || formData.transactionType === 8) { //if VIP Recharge or Easy Post Recharge
      let findCompany = activeSellerList.filter(item => item.Id === currentUserDetails.companyId)[0]; // NOSONAR
      setFormData({
        ...formData,
        topupCompanyId: findCompany,
      });
      dispatch(getSellers(currentUserDetails.companyId));
    }
  }, [formData.transactionType]);

  const TopUpForm = (item, name, sellerdetail) => {
    if (name === "topupCompanyId") {
      // Invalidate stale sellers synchronously so the effect can't reuse the previous
      // company's sellers to repopulate the dropdown or auto-select a wrong seller.
      dispatch({ type: GET_SELLERS, payload: [] });
      setSellerList([]);
      if (!(formData.transactionType === 7 || formData.transactionType === 8)) {
        dispatch(getSellers(item?.Id));
      }
      setFormData({
        ...formData,
        topupSellerId: null,
        [name]: item,
        availableAmount: null,
      });
    } else {
      setFormData({ ...formData, [name]: item });
    }
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleDateChange = (e, name) => {
    setFormData({
      ...formData,
      [name]: moment(e).format("MM-DD-YYYY"),
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleAmountChange = (event) => {
    const { value } = event.target;
    setAmount(value);
    TopUpForm(value, "amount");
  };

  const handleAdjustmentComplete = () => {
    dispatch({
      type: GET_WALLET_BALANCE,
      payload: [],
    });
    dispatch({
      type: GET_SINGLE_FUNDS_DATA,
      payload: [],
    });
    dispatch({
      type: GET_SELLERS,
      payload: [],
    });
    props.onHide();
  };

  const saveTopUpData = async () => {
    if (isAdjustmentFormValid(formData)) {
      setShowLoader(true);
      const success = await Promise.resolve(dispatch(
        AdjustWalletDetails(
          {
            ...formData,
            createdDate: moment(formData?.createdDate).format("MM-DD-YYYY HH:mm:ss"),
            topupCompanyId: formData?.topupCompanyId?.Id,
            topupCompayId: formData?.topupCompanyId?.Id,
            topupSellerId: formData?.topupSellerId?.value,
            role: createdBy?.Value?.role,
            companySellerId: createdBy?.Value?.companySellerId,
          },
          sellerWalletBalance,
          setAmount,
          createdBy?.Value?.isAdmin,
          handleAdjustmentComplete
        )
      ));
      if (!success) {
        setShowLoader(false);
      }
    }
    const validationErrors = getAdjustmentValidationErrors(formData);
    if (validationErrors) setErrors(validationErrors);
  };

  const handleCancel = () => {
    handleAdjustmentComplete();
  };

  return (
    <Modal
      {...props}
      size="lg"
      className="topUpModal"
      backdrop="static"
      centered
      show={showModal}
    >
      <div className="top_modal_header_container">
        <span className="">Amount Adjustment</span>
        <div className="modalDeleteWrapper">
          <button
            type="button"
            onClick={() => handleCancel()}
            className="btn-close"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div className="modal_container_rate_card">
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Transaction Type:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={transactionTypeList}
                onChange={(value) => TopUpForm(value.value, "transactionType")}
                className="activeSellerListInput"
                id="listlistst"
                classNamePrefix={'list'}
              />
            </div>
            <p className="error dialogError"> {errors?.transactionType}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Company Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={props?.activeSellerList}
                onChange={(value) => TopUpForm(value, "topupCompanyId", "seller")}
                className="activeSellerListInput"
                value={formData.topupCompanyId}
                classNamePrefix={'topupCompanyId'}
                isDisabled={formData.transactionType === 7 || formData.transactionType === 8}
              />
            </div>
            <p className="error dialogError"> {errors?.SellerName}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel ">
            <span className="input-label fnt-wgt-editmgmt">Seller Name:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className={"select_react"}>
              <Select
                options={sellerList}
                onChange={(value) => TopUpForm(value, "topupSellerId")}
                className="activeSellerListInput"
                isDisabled={formData.transactionType === 7 || formData.transactionType === 8}
                value={formData?.topupSellerId}
                id="text6"
                classNamePrefix={'list2'}
              />
            </div>
            <p className="error dialogError"> {errors?.topupSellerId}</p>
          </div>
        </div>
        {!(formData.transactionType === 6 || formData.transactionType === 7) && (
          <div className="row modal_input">
            <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
              <span className="input-label fnt-wgt-editmgmt">Available Balance ($):</span>
            </div>
            <div className="col-lg-8 col-sm-12">
              <input
                onChange={(e) => TopUpForm(e, "AvailableBalance")}
                disabled
                value={
                  sellerWalletBalance?.length &&
                  sellerWalletBalance?.[0]?.availableAmount
                }
                className="form-control availableBalanceInput"
                type="text"
              />
              <p className="error dialogError">{errors.Name}</p>
            </div>
          </div>
        )}
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Transaction Date:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <DatePicker
              data-testid={'createdDate'}
              className="form-control createdDate"
              showIcon
              dateFormat="MM-dd-yyyy"
              name="createdDate"
              onChange={(e) => handleDateChange(e, "createdDate")}
              value={formData?.createdDate || moment(new Date()).format("MM-DD-YYYY")}
            />
            <p className="error dialogError">{errors.createdDate}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Enter The Amount ($):</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <InputCalculator
              value={String(formData.amount || "")}
              onChange={handleAmountChange}
              className="amountInput"
              placeholder="Enter Amount"
              maxLength={500}
              id="text2"
            />
            <p className="error dialogError">{errors.amount}</p>
          </div>
        </div>
        <div className="row modal_input">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt">Description:</span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <textarea
              onChange={(e) => TopUpForm(e.target.value, "description")}
              className="form-control amountInput text-area"
              type="text"
              id="text1"
            />
          </div>
        </div>
        <div className="row modal_input fontFix">
          <div className="col-lg-4 col-sm-12 mobMb-10 formLabel">
            <span className="input-label fnt-wgt-editmgmt"></span>
          </div>
          <div className="col-lg-8 col-sm-12">
            <input
              className="sendNotification mr-1"
              type="checkbox"
              checked={formData.shouldSendEmail}
              onChange={(e) => setFormData({ ...formData, shouldSendEmail: e.target.checked })}
            ></input> Send Notification Email
          </div>
        </div>
        <Row className="modaL_footer">
          <div
            className="col-12 noPadding"
            style={{ textAlign: "right" }}
            xs={12} // NOSONAR
          >
            <button
              className="btn cus-seconday-bg-btn"
              id="dan"
              disabled={showLoader}
              onClick={() => handleCancel()}
            >
              Cancel
            </button>
            <button
              id="saveTopUpBtn"
              className="btn cus-seconday-bg-btn marginLeft5"
              disabled={showLoader}
              onClick={(e) => {
                saveTopUpData();
              }}
            >
              Adjust
            </button>
          </div>
        </Row>
      </div>
    </Modal>
  );
}

PriceAdjustModal.propTypes = {
  fundList: PropTypes.array.isRequired,
  activeSellerList: PropTypes.array.isRequired,
  onHide: PropTypes.func.isRequired,
  showModal: PropTypes.bool
};

export default PriceAdjustModal;
